var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 237,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 156,
    width: 1135,
    height: 237
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-355 -156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.698 156 1031.8 156 1121 392 1044.71 392 991.55 222.164 939.072 392 865 392 952.698 156Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.857 157 577 157 577 209.265 502.804 210.124 502.804 393 430.053 393 430.053 209.266 355 209.266 355.857 157Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.373 157 649.249 157C671.819 157 689.068 158.932 700.998 162.795 712.927 166.659 722.546 173.823 729.854 184.287 737.162 194.751 740.816 207.495 740.816 222.52 740.816 235.613 738.02 246.908 732.428 256.407 726.836 265.905 719.148 273.605 709.363 279.508 703.126 283.264 694.577 286.376 683.715 288.845 692.414 291.746 698.751 294.646 702.726 297.545 705.411 299.478 709.304 303.614 714.406 309.952 719.507 316.29 722.917 321.178 724.635 324.615L760 393 677.484 393 638.449 320.88C633.505 311.543 629.099 305.479 625.229 302.689 619.963 299.04 613.999 297.216 607.335 297.216L600.887 297.216C600.831 281.818 600.774 266.42 600.718 251.022L600.887 251.022 600.887 252.624 631.678 252.624C635.01 252.624 641.458 251.55 651.023 249.404 655.859 248.438 659.809 245.97 662.872 241.999 665.935 238.028 668.196 233.091 667.466 228.315 666.736 223.539 664.385 216.573 658.492 213.344 652.599 210.116 645.435 208.944 632.108 208.944 621.414 209.233 610.721 207.805 600.028 208.952 599.856 193.066 600.544 172.887 600.373 157Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 194 847 194 847 260 777 260 777 194Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 300 847 300 847 365 777 365 777 300Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 341 1490 341 1490 392 1307 392 1307 341Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 249 1490 249 1490 300 1307 300 1307 249Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 157 1490 157 1490 208 1307 208 1307 157Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.23 156 1284 156 1284 209.055 1234.23 209.055 1234.23 156ZM1230.8 156 1234.23 156.373 1234.23 209.134 1232.58 208.773C1215.98 208.773 1203.26 215.2 1194.43 228.055 1187.74 237.591 1184.4 252.569 1184.4 272.988 1184.4 298.282 1188.91 313.986 1196.37 325 1203.82 336.014 1214.69 339.071 1229.13 339.071 1239.45 341.429 1249.78 340.354 1260.1 340.995L1284 341.15 1284 392 1234.2 392C1234.2 392 1234.2 392 1234.2 392 1234.2 392 1234.2 392 1234.19 392L1234.17 392 1234.17 391.998 1199.09 389.297C1188.57 387.495 1179.23 384.792 1171.06 381.188 1154.73 373.98 1140.64 361.301 1128.78 343.151 1116.93 325.002 1111 301.77 1111 273.455 1111 235.705 1121.43 206.691 1142.28 186.415 1163.14 166.138 1192.65 156 1230.8 156Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.32d6458c1126665eccb07a46c135d47b.svg";
export { ForwardRef as ReactComponent };